import React, { useImperativeHandle, useState, forwardRef } from "react";
import clsx from "clsx";
import { Grid } from "@mui/material";
import { Box, Button, Form, Stack, Typography } from "@curves/ui-base";
import useOrderBatchPaymentApi from "@apis/useOrderBatchPaymentApi";
import useExportActionDialog from "@util/hook/useExportActionDialog";
import { isFunction } from "@util/utils";

/** ================================
 * 📌 批次匯出訂單
 *  ================================
 */
const BatchExcelDownloadAction = forwardRef(({
												 searchParams,
												 onHideAction,
												 getCheckedSourceData,
												 className
											 }, ref) => {
	const { type, date } = searchParams || {};
	const { postOrderBatchPaymentExportOrderApi } = useOrderBatchPaymentApi();
	const { showExportConfirmDialog } = useExportActionDialog({ checkExportPermission: false });
	const [selectionStats, setSelectionStats] = useState({
		count: 0
	});

	const doOrderBatchPaymentExportOrderApi = async (params) => {
		await showExportConfirmDialog(params, (nextParams) => {
			let resp = postOrderBatchPaymentExportOrderApi(nextParams);

			if (resp) onHideAction();
		});
	};

	const getParams = () => {
		let params = {
			assignmentMonth: date,
			billingCategory: type
		};

		if (isFunction(getCheckedSourceData)) {
			params.orderIDs = getCheckedSourceData().map((item) => item.orderID);
		}

		return params;
	};

	const handleSubmit = () => {
		const params = getParams();
		if (params.orderIDs.length > 0) {
			doOrderBatchPaymentExportOrderApi(params);
		}
	};

	useImperativeHandle(ref, () => ({
			setSelectionStats: (params) => setSelectionStats(params)
		}),
		// eslint-disable-next-line
		[]);


	return (
		<Box className={clsx("mb-2 batch-controller-panel", className)}>
			<Form onSubmit={handleSubmit}>
				<Grid className={className} spacing={2} container>
					<Grid xs={7} item>
						<Typography className={"font-weight-bold"} variant={"body1"}>
							請選擇要匯出的名單
						</Typography>
						<Typography variant={"body1"}>
							匯出筆數：<strong className={"h6 text-primary"}>{selectionStats.count}</strong>
						</Typography>
					</Grid>
					<Grid xs={5} item>
						<Stack className={"h-100"} direction={"column"} justifyContent={"end"}>
							<Box className={"btn-group"}>
								<Button color={"grey"} variant={"outlined"} onClick={onHideAction}>
									取消
								</Button>
								<Button type={"submit"} variant={"outlined"}>
									進行批次匯出
								</Button>
							</Box>
						</Stack>
					</Grid>
				</Grid>
			</Form>
		</Box>
	);
});

export default BatchExcelDownloadAction;
